export default __webpack_public_path__ + "static/media/indexBg.501f3714.jpg";